<se-fe-modal #modal>
  <div seFeModalHeader>
    <se-fe-modal-header
      seFeDataTitle="Add Person">
    </se-fe-modal-header>
    @if (multiStep) {
      <div>
        <se-fe-progress-bar
          [seFeDataSegmented]="true"
          [seFeDataCompleted]="progressComplete"
          seFeDataTotal="2">
        </se-fe-progress-bar>
      </div>
      <div class="new-person-progress-text">{{ progressComplete }} of 2 steps complete</div>
    }
  </div>
  <div seFeModalContent>
    <div>
      @switch (step) {
        @case (stepEnum.SelectRelationship) {
          <se-po-select-relationship #selectRelationship>
          </se-po-select-relationship>
        }
        @case (stepEnum.AddChild) {
          <se-po-add-child-profile #childProfile></se-po-add-child-profile>
        }
        @case (stepEnum.AddGuardian) {
          <se-po-add-guardian
            #addGuardian
            [guardians]="guardians"
            [profiles]="profiles"
            (guardianInvited)="modal.close()">
          </se-po-add-guardian>
        }
      }
    </div>
  </div>
  <div seFeModalFooter class="footer-buttons">
    <div>
      @if (step && multiStep) {
        <se-fe-back-button
          (click)="back()"
        >Back</se-fe-back-button>
      }
    </div>
    <se-fe-button
      seFeDataEmphasis="high"
    (click)="continue()">{{ continueLabel }}</se-fe-button>
  </div>
</se-fe-modal>
